import Icon from '../components/Icon.vue'

Icon.register({
  'grin-tongue-squint': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M293.1 374.6c0.8 0.4-0.5-0.3 19 9.3v64c0 35.6-29.2 64.5-64.9 64-35.1-0.4-63.1-29.7-63.1-64.9v-63c19.2-9.6 18-9 18.9-9.4 14.4-6.5 31.1 2.2 34.6 17.6l1.8 7.8c2.1 9.2 15.2 9.2 17.3 0l1.8-7.8c3.5-15.4 20.2-24.1 34.6-17.6zM248 8c137 0 248 111 248 248 0 106.3-67 196.7-161 232 5.6-12.2 9-25.7 9-40v-45.5c24.7-16.2 43.5-38.1 47.8-63.8 1.9-11.8-9.3-21.6-20.7-17.9-30.2 9.7-75.1 15.2-123.1 15.2s-92.9-5.5-123.1-15.2c-11.5-3.6-22.7 6.1-20.7 17.9 4.3 25.7 23.1 47.6 47.8 63.8v45.5c0 14.3 3.4 27.8 9 40-94-35.3-161-125.7-161-232 0-137 111-248 248-248zM214.2 218.3c7.7-4.7 7.7-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.6 10.4 3.9 24.8 15.4 18zM377.2 248.3l-33.6-40.3 33.6-40.3c8.5-10.3-3.7-24.9-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24.1-7.6 15.4-18z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-tongue-squint.js
// module id = 1410
// module chunks = 0